import React from 'react';

const serviceIcons = {
  'critical-thinking': (
    <svg viewBox="0 0 48 48" focusable="false">
      <path d="M24 38v-8m0 0c-4 0-7-1-9-3.5S12 21 13 17.5 16 11 20 9.5c2-1 4-1.5 4-1.5s2 .5 4 1.5 5 4.5 6 8S34 25 32 27.5 28 30 24 30Z" fill="currentColor" opacity="0.13" />
      <path d="M20 9.5C16.5 11 14 14 13 17.5S12.5 24 15 27s5 3.5 9 3.5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28 9.5C31.5 11 34 14 35 17.5S35.5 24 33 27s-5 3.5-9 3.5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24 10v20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
      <path d="M17 17c2 1 4.5 1.5 7 0m0 5c-2.5 1.5-5 1-7-1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M31 17c-2 1-4.5 1.5-7 0m0 5c2.5 1.5 5 1 7-1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M24 30v8" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M21 34h6m-5 3h4" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  literacy: (
    <svg viewBox="0 0 48 48" focusable="false">
      <path d="M14 14.5c0-1.4 1.1-2.5 2.5-2.5H34v22H16.5a2.5 2.5 0 0 0-2.5 2.5V14.5Z" fill="currentColor" opacity="0.14" />
      <path d="M14 14.5c0-1.4 1.1-2.5 2.5-2.5H34v22H16.5a2.5 2.5 0 0 0-2.5 2.5V14.5Z" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <path d="M20 19h8m-8 5h10m-10 5h6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  numeracy: (
    <svg viewBox="0 0 48 48" focusable="false">
      <rect x="11" y="11" width="26" height="26" rx="8" fill="currentColor" opacity="0.12" />
      <text x="24" y="30" textAnchor="middle" fill="currentColor" fontFamily="system-ui, sans-serif" fontWeight="700" fontSize="18">101</text>
    </svg>
  ),
  science: (
    <svg viewBox="0 0 48 48" focusable="false">
      <path d="M19 12v6l-7.5 12.2A4 4 0 0 0 14.9 36h18.2a4 4 0 0 0 3.4-5.8L29 18v-6" fill="currentColor" opacity="0.13" />
      <path d="M19 12h10m-9 6v4.1l-8.5 13.8h25L28 22.1V18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 29c1.5-1 2.8-1 4.3 0s2.8 1 4.3 0 2.8-1 4.4 0" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
};

function ServiceCard({ title, description, icon }) {
  return (
    <article className={`service-card service-card--${icon} surface-card`}>
      <span className="service-card__icon" aria-hidden="true">
        {serviceIcons[icon]}
      </span>
      <div className="service-card__content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </article>
  );
}

export default ServiceCard;
